enum TextFieldChangeType {
  FONT_FAMILY = 'fontFamily',
  FONT_SIZE = 'fontSize',
  TEXT_ALIGN = 'textAlign',
  VALUE = 'value',
}

export default TextFieldChangeType;
